import React from "react";
import { useLocalizedStrings } from "../../../Localization";

export type ApplicantCountFormFieldsProps = {
};

export const ApplicantCountFormFields: React.FC<ApplicantCountFormFieldsProps> = ({}) => {
  const L = useLocalizedStrings()

  return (
    <>
      <div className="p-4 bg-gray-50 rounded-lg">
        <div className="text-sm text-gray-600">
          {L.admin_panel.dashboards.applicant_count_desc}
        </div>
      </div>
    </>
  );
};